/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart
    document.querySelector("#miniCart").showModal();
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").textContent = `Your Cart (${cart.item_count})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            if (!item.variant_title.includes("/")) {
                return `<div class="miniCartBodyItemVariant">${item.variant_title + " Pets"}</div>`;
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a>`;
                    continue;
                }

                // catch all
                HTML += `<span>${key}: ${item.properties[key]}</span>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // price HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null;

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            // check if comparePrice exists
            if (comparePrice) {
                HTML += `<s>${price(comparePrice, false)}</s>`;
            }

            /****************** actual price ******************/

            HTML += price(item.final_line_price, false);

            return HTML;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                <div>
                    <div class="miniCartBodyItemFlex">
                    <div class="loox-rating" data-id="${item.product_id}" 
                            data-rating="${productMetafields[item.product_id + '-1']}"
                            data-raters="${productMetafields[item.product_id + '-2']}"></div>
                        <div class="miniCartBodyItemTitle">${item.product_title}</div>
                        ${variantHTML()}
                        ${propertiesHTML()}
                        <button class="miniCartBodyItemRemove">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M15 5L5 15M5 5L15 15" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <div class="miniCartBodyItemFlexBottom">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M2.5 6.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path d="M6 3V10M2.5 6.5H9.5" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                </div>
            </div>
        `);
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // update subtotal
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);

    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }
}

// upsell item selection
document.querySelectorAll('.miniCartUpsellItemButton').forEach(button => {
    button.addEventListener("click", function () {
        // toggle active class
        this.parentElement.classList.toggle("selected");
    });
})

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check for upsells
    document.querySelectorAll('.miniCartUpsellItem.selected')?.forEach(upsell => {
        formData.items.push({
            quantity: 1,
            id: upsell.dataset.variant
        });
    });

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));

/********************
 Countdown
 *******************/

if (document.querySelector("#cartCountdown")) {
    // countdown is 10 minutes from first page load (use session storage)
    let cartCountdownDate = new Date().getTime() + 600000;

    // check if countdown is in local storage
    if (sessionStorage.cartCountdown) {
        cartCountdownDate = parseInt(sessionStorage.cartCountdown);
    }

    // update countdown in local storage
    sessionStorage.cartCountdown = cartCountdownDate;

    // update countdown every second
    const cartCountdownInterval = setInterval(function () {
        // get current time
        let now = new Date().getTime();

        // calculate difference
        let difference = cartCountdownDate - now;

        // if countdown is over us complete message and clear interval
        if (difference < 0) {
            document.querySelector("#cartCountdown").innerText = `In Stock Only - Items Selling Fast`;
            clearInterval(cartCountdownInterval);
            return;
        }

        // used as a comparison
        const hour = 60 * 60 * 1000;
        const minute = 60 * 1000;
        const second = 1000;

        // calculate remaining time
        let minutesLeft = Math.floor((difference % (hour)) / (minute));
        let secondsLeft = Math.floor((difference % (minute)) / second);

        // if less than 10 seconds, add a 0
        if (secondsLeft < 10) {
            secondsLeft = `0${secondsLeft}`;
        }

        // update countdown
        document.querySelector("#cartCountdown").innerHTML = `Your is cart reserved for <span>0${minutesLeft}:${secondsLeft}s</span>`;
    }, 1000);
}
